/**
 * Pulsing red dot + count, shown next to a nav label when unread training
 * announcements exist. Returns null when count === 0 so the nav stays clean.
 */
export default function UnreadBadge({ count, className = "" }) {
  if (!count || count <= 0) return null;
  const display = count > 9 ? "9+" : String(count);
  return (
    <span
      className={`relative inline-flex items-center justify-center ml-auto ${className}`}
      data-testid="training-unread-badge"
      data-unread-count={count}
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-rose-500 opacity-60 animate-ping" />
      <span className="relative inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-semibold rounded-full bg-rose-500 text-white">
        {display}
      </span>
    </span>
  );
}
